import React, { FC } from "react";
import classnames from "classnames";

import "./index.scss";

export interface MysteryBadgeArtProps {
  /** The badge's resolved icon URL (server `icon_url` or bundled art, from `resolveBadgeIcon`), or
   *  `null` when it has neither. */
  iconUrl: string | null;
  /** The caller's own icon element class (`badge-card-icon` / `badge-details-icon`) -- forwarded onto
   *  this component's root so the silhouette inherits that class's existing size and layout rules
   *  instead of this shelf needing to know either caller's dimensions. */
  className: string;
}

/**
 * The silhouette drawn for every unearned badge, in place of its real, full-colour artwork: the same
 * resolved icon URL masked over a FADED brand-violet fill (so only its outline shows, never the real
 * picture, and never at full, dominant strength), with a centred "?" on top. `iconUrl === null` -- a
 * badge with no served or bundled art at all -- falls back to the same faded fill in a plain round
 * shape, so a locked tile is never left blank or empty-looking. See `index.scss` for the exact colours.
 *
 * Shared by `BadgeCard` and `BadgeOverlayDetailsContainer`: both already resolve a badge's icon via
 * `resolveBadgeIcon` before choosing which of the real icon div or this component to render, so this
 * component never resolves anything itself.
 */
const MysteryBadgeArt: FC<MysteryBadgeArtProps> = (props) => {
  const { iconUrl, className } = props;

  return (
    <div
      className={classnames(className, "mystery-badge-art", iconUrl === null && "mystery-badge-art--no-art")}
      style={iconUrl ? { WebkitMaskImage: `url("${iconUrl}")`, maskImage: `url("${iconUrl}")` } : undefined}
    >
      <span className="mystery-badge-art-glyph" aria-hidden="true">
        ?
      </span>
    </div>
  );
};

export default MysteryBadgeArt;
